import React from "react"
import { Redirect } from "react-router-dom"
// User profile
//import UserProfile from "../pages/Authentication/UserProfile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// 404
import Page404 from "../helpers/page-404";

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Media Buyers Tools
import MediaBuyerBudgets from '../pages/MediaBuyingTool/MediaBuyingBudgets';
import MediaBuyerPlans from '../pages/MediaBuyingTool/MediaBuyingPlans';

// Invoices
import Invoices from '../pages/Accounting/Invoices/index'
import InvoicesProfile from '../pages/Accounting/Invoices/InvoicesProfile/index'
import AddInvoices from "../pages/Accounting/Invoices/AddIvoices/AddInvoices";

// Settings
import SalaryBonuses from "../pages/Settings/SalaryBonuses/index";
import Users from "../pages/Settings/Users/index";
import PositionsList from "../pages/Settings/Positions/ListPositions/index";
import UserProfile from "../pages/Settings/Users/UserProfile/index";

// Clients
import Clients from "../pages/Clients/ClientsList";
import ClientInfo from "../pages/Clients/ClientInfo";
import ClientsVK from "../pages/Integration/ClientsVK";
import Campaigns from "../pages/Campaigns/CampaignList";
import CampaignInfo from "../pages/Campaigns/CampaignInfo";
import CampaignsVkList from "../pages/Integration/CampaignVkList";
import BannersVkList from "../pages/Integration/BannersVK";
import AddClient from '../pages/Clients/AddClient';
import OffersAddPage from "../pages/Offers/OffersAddPage";
import Formats from "../pages/Campaigns/CampaignFormats/index";
import EditMediaBuyer from "../pages/MediaBuyingTool/MediaBuyingBudgets/EditMediaBuyer/EditMediaBuyer";
import EditMediaBuyerPlan from "../pages/MediaBuyingTool/MediaBuyingPlans/EditMediaBuyerPlan";
import Statuses from "../pages/Campaigns/CampaignStatuses/index";
import Sources from "../pages/Campaigns/CampaignSources/index";
import DirectionTypes from "../pages/Campaigns/CampaignDirectionTypes/index";
import OfferInfo from "../pages/Offers";
import OffersTrackersProfile from "../pages/Offers/OffersTrackers/OfferTrackerProfile/index";
import DeviceTypes from "../pages/Campaigns/CampaignDeviceTypes/index";
import OfferTypes from "../pages/Campaigns/CampaignOfferTypes/index";
import CustomNames from "../pages/Campaigns/CampaignCustomNames/index";
import MediaBuyers from "../pages/Campaigns/CampaignsMediaBuyers";
import PaymentFormulas from "../pages/PaymentFormulas/index";
import AddPaymentFormulas from "../pages/PaymentFormulas/AddPaymentFormulas/index";
import PaymentFormulasProfile from "../pages/PaymentFormulas/PaymentFormulasProfile/index";
import AddApplication from "../pages/Clients/AddApplication/index";
import EditApplication from "../pages/Clients/EditApplication/index";
import EditMediaBuyerBudget from '../pages/Offers/OfferMediaBuyersBudget/components/EditMediaBuyersBudget';
import EditMediaBuyerPlanOffer from '../pages/Offers/OfferMediaBuyerPlans/components/EditMediaBuyerPlan';
import ComingSoon from '../../src/helpers/ComingSoon';
import AdvertisingAccounts from "../pages/Campaigns/CampaignAdvertisingAccounts";
import Cashbacks from "../pages/Campaigns/CampaignCashbacks";
import CashbacksAddPage from "../pages/Campaigns/CampaignCashbacks/CampaignCashbackAdd";
import CampaignCashbackProfile from "../pages/Campaigns/CampaignCashbacks/CampaignCashbackProfile";
import Contractors from "../pages/Accounting/Contractors/index";
import AddContractors from "../pages/Accounting/Contractors/AddContractors/index";
import ContractorsProfile from "../pages/Accounting/Contractors/ContractorsProfile/index";
import ServiceProviders from "../pages/Accounting/ServiceProviders/index";
import AddServiceProvider from "../pages/Accounting/ServiceProviders/AddServiceProvider/index";
import ServiceProviderProfile from "../pages/Accounting/ServiceProviders/ServiceProviderProfile/index";
import TikTokAdvertisers from "../pages/Integration/TikTokAdvertisers";
import BannersMT from "../pages/Integration/BannersMT";
import CampaignsMT from "../pages/Integration/CampaignsMT";
import AgenciesMT from "../pages/Integration/AgenciesMT";
import QualityNonCohortReport from "../pages/Reporting/QualityNonCohortReport/index";
import CampaignValidator from "../pages/Campaigns/CampaignValidator"
//import AppList from "../pages/Apps/AppList/index";
import QualityCampaignStats from "../pages/Reporting/QualityNonCohortReport/common/QualityCampaignStats";
import QualityAdgroupsStats from "../pages/Reporting/QualityNonCohortReport/common/QualityAdgroupsStats";
import QualityBannerStats from "../pages/Reporting/QualityNonCohortReport/common/QualityBannerStats";
import QualityMediaSource from "../pages/Reporting/QualityNonCohortReport/common/QualityMediaSource";
import TopManagementReports from "../pages/Reporting/TopManagementReports/index";
import PaymentCostInspectionReport from "../pages/Reporting/PaymentCostInspectionReport/index";
import UploadWidget from "../pages/UploadData/UploadWidget/index";
import FinanceReport from "../pages/Reporting/FinanceReport/index";
import ManagersReport from "../pages/Reporting/ManagersReport/index";
import ClientFinanceReport from "../pages/Reporting/FinanceReport/common/Client/ClientFinanceReport";
import DetailedByOffersReport from "../pages/Reporting/DetailedByOffersReport/index";
import DetailedNonCohortReport from "../pages/Reporting/DetailedNonCohortReport/index";
import NonCahortQualityReport from "../pages/Reporting/NonCahortQualityReport/index";

// Legal entity
import LegalEntity from '../pages/Accounting/LegalEntity/index'
import AddLegalEntity from '../pages/Accounting/LegalEntity/AddLegalEntity/index'
import LegalEntityProfile from '../pages/Accounting/LegalEntity/LegalEntityProfile/index'

// Account manager
import Plans from '../pages/AccountManagers/Plans/index'
import EditPlansForm from '../pages/AccountManagers/Plans/components/common/EditPlansForm'

// Reports
import CohortReports from '../pages/Reporting/CohortReports/index'
import ApplicationListPage from "../components/ApplicationList"
import ClientsListPage from "../components/ClientsList"
import RentStatsMain from "../pages/Reporting/QualityRentReport/RentStatsMain/index"

// Invoice templates
import InvoiceTemplates from "../pages/Accounting/InvoiceTemplates/index"

// Edit payment form
import EditPayment from "../pages/Clients/ClientInfo/Payments/components/EditPayment"
import CreateTikTokCampaign from "../pages/Campaigns/CampaignCreateTikTok"

// Reconciliation
import Reconciliation from "../pages/Accounting/Reconciliation";

// Top Management Dashboard
import Overview from "../pages/Reporting/Overview";
import NotificationsPage from "../pages/Notifications";

// ID Gen
import IDGenerator from "../pages/Settings/IDGenerator";

// User Actions
import UserActionsPage from "../pages/Reporting/UsersActions";

// Cabinet Limit
import CabinetLimits from "../pages/Campaigns/CabinetLimits"

// Mapper Files
import UploadHistory from "../pages/UploadData/UploadHistory"


const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard, permission: false },
  { path: "/health", exact: true, component: NotificationsPage, permission: "view_healthreport" },
  { path: "/id-generator", exact: true, component: IDGenerator, permission: "view_idgenerator" },

  //profile
  { path: "/profile/:userId", exact: true, component: UserProfile, permission: false },
  { path: "/campaigns", exact: true, component: Campaigns, permission: "view_campaignmodel" },
  { path: "/campaigns/:campaignId", exact: true, component: CampaignInfo, permission: "view_campaignmodel" },
  { path: "/detailed-by-offers-report", exact: true, component: DetailedByOffersReport, permission: "view_qualityreportmodel" },
  // { path: "/detailed-non-cahort-report", exact: true, component: DetailedNlonCohortReport, permission: "view_qualityreportmodel" },
  // { path: "/non-cahort-/", exact: true, component: NonCahortQualityReport, permission: "view_qualityreportmodel" },
  { path: "/managers-report", exact: true, component: ManagersReport, permission: "view_qualityreportmodel" },
  { path: "/overview", exact: true, component: Overview, permission: ["view_topmanagmentreport"] }, // userreportviews [view_topmanagmentreport_byaccountmanager"]
  { path: "/finance-report", exact: true, component: FinanceReport, permission: "view_qualityreportmodel" },
  { path: "/finance-report/:client", exact: true, component: ClientFinanceReport, permission: "view_qualityreportmodel" },
  { path: "/quality-report", exact: true, component: () => <ApplicationListPage title="Quality Report" href={'quality-report'}/>, permission: "view_qualitynoncohortreport" },
  // { path: "/quality-non-cahort-report", exact: true, component: QualityNonCohortReport, permission: "view_qualityreportmodel" }, // Need to permission
  { path: "/quality-report/:app_id/:media_source", exact: true, component: QualityCampaignStats, permission: "view_qualitynoncohortreport" },
  { path: "/quality-report/:app_id/:media_source/:campaign_id", exact: true, component: QualityAdgroupsStats, permission: "view_qualitynoncohortreport" },
  { path: "/quality-report/:app_id/:media_source/:campaign_id/:adgroup_id", exact: true, component: QualityBannerStats, permission: "view_qualitynoncohortreport" },
  { path: "/quality-report/:app_id", exact: true, component: QualityMediaSource, permission: "view_qualitynoncohortreport" },
  // { path: "/top-management-report", exact: true, component: TopManagementReports, permission: "view_topmanagmentreport" },
  { path: "/payment-cost-inspection-reports", exact: true, component: PaymentCostInspectionReport, permission: false },
  { path: "/media-buyer-budget", exact: true, component: MediaBuyerBudgets, permission: "view_mediabuyerbudgetmodel" },
  { path: "/media-buyer-budget/:id", exact: true, component: EditMediaBuyer, permission: "change_mediabuyerbudgetmodel" },
  { path: "/positions", exact: true, component: PositionsList, permission: "view_positionmodel" },
  { path: "/clients/add", exact: true, component: AddClient, permission: "add_clientmodel" },
  { path: "/clients", exact: true, component: Clients, permission: "view_clientmodel" },
  { path: "/clients/:clientId", exact: true, component: ClientInfo, permission: "view_clientmodel" },
  { path: "/clients/:clientId/payment/:paymentId", exact: true, component: EditPayment, permission: "view_bankuploadingmodel"},
  { path: "/campaigns_vk", exact: true, component: CampaignsVkList, permission: "view_integrationvkcampaignmodel" },
  { path: "/campaigns_tt/add", exact: true, component: CreateTikTokCampaign, permission: false },
  { path: "/campaign-validator", exact: true, component: CampaignValidator, permission: false },
  { path: "/clients_vk", exact: true, component: ClientsVK, permission: "view_integrationvkclientmodel" },
  { path: "/banners_vk", exact: true, component: BannersVkList, permission: "view_integrationvkbannersmodel" },
  { path: "/advertisers_tiktok", exact: true, component: TikTokAdvertisers, permission: "view_integrationtiktokadvertisermodel" },
  { path: "/banners_mytarget", exact: true, component: BannersMT, permission: "view_integrationmytargetbannermodel" },
  { path: "/campaigns_mytarget", exact: true, component: CampaignsMT, permission: "view_integrationmytargetcampaignmodel" },
  { path: "/agencies_mytarget", exact: true, component: AgenciesMT, permission: "view_integrationmytargetagencymodel" },
  { path: "/applications/add/:clientId", exact: true, component: AddApplication, permission: "view_clientmodel" },
  { path: "/client/:clientId/application/:appId", exact: true, component: EditApplication, permission: "view_clientmodel" },
  //{ path: "/applications", exact: true, component: AppList, permission: "view_clientmodel" },
  //{ path: "/payment-formulas", exact: true, component: PaymentFormulas, permission: "view_paymentformulamodel" }, HIDDEN PAYMENT FORMULA
  { path: "/payment-formulas/add", exact: true, component: AddPaymentFormulas, permission: "add_paymentformulamodel" },
  { path: "/payment-formulas/:formulaId", exact: true, component: PaymentFormulasProfile, permission: "view_paymentformulamodel" },
  { path: "/offers/add", exact: true, component: OffersAddPage, permission: "add_appoffermodel" },
  { path: "/offers/:offerId", exact: true, component: OfferInfo, permission: "view_appoffermodel" },
  { path: "/offers/:offerId/tracker/:trackerId", exact: true, component: OffersTrackersProfile, permission: "view_offertrackermodel" },
  { path: "/offers/:offerId/media-buyer-budget/:id", exact: true, component: EditMediaBuyerBudget, permission: "change_mediabuyerbudgetmodel" },
  { path: "/offers/:offerId/media-buyer-plan/:id", exact: true, component: EditMediaBuyerPlanOffer, permission: "change_mediabuyerplanmodel" },
  { path: "/formats", exact: true, component: Formats, permission: "view_campaignformatmodel" },
  { path: "/statuses", exact: true, component: Statuses, permission: "view_campaignstatusmodel" },
  { path: "/sources", exact: true, component: Sources, permission: "view_campaignsourcemodel" },
  { path: "/direction-types", exact: true, component: DirectionTypes, permission: "view_campaigndirectiontypemodel" },
  { path: "/device-types", exact: true, component: DeviceTypes, permission: "view_campaigndevicetypemodel" },
  { path: "/offer-types", exact: true, component: OfferTypes, permission: "view_campaignoffertypemodel" },
  { path: "/media-buyers", exact: true, component: MediaBuyers, permission: "view_campaignmediabuyermodel"},
  { path: "/advertising-accounts", exact: true, component: AdvertisingAccounts, permission: "view_campaigncabinetmodel"},
  { path: "/cashbacks", exact: true, component: Cashbacks, permission: "view_cashbackmodel"},
  { path: "/cashbacks/add", exact: true, component: CashbacksAddPage, permission: "add_cashbackmodel"},
  { path: "/cashbacks/:cashbackId", exact: true, component: CampaignCashbackProfile, permission: "view_cashbackmodel"},
  { path: "/custom-names", exact: true, component: CustomNames, permission: "view_campaigncustomnamemodel" },
  { path: "/invoices", exact: true, component: Invoices, permission: "view_invoice" },
  { path: "/invoices/add", exact: true, component: AddInvoices, permission: "add_invoice" },  // neeed permissions
  { path: "/invoices/:invoiceId", exact: true, component: InvoicesProfile, permission: "view_invoice" },
  { path: "/contractors", exact: true, component: Contractors, permission: ["is_head_of_accountmanager", "is_admin", "is_accountmanager"] },
  { path: "/contractors/add", exact: true, component: AddContractors, permission: "add_contractmodel" },
  { path: "/contractors/:contractorId", exact: true, component: ContractorsProfile, permission: "view_contractmodel" },
  { path: "/reconciliations", exact: true, component: Reconciliation, permission: "view_accountreconciliations" },
  { path: "/service-providers", exact: true, component: ServiceProviders, permission: ["view_serviceprovidermodel", "is_head_of_accountmanager", "is_admin", "is_accountmanager"] },
  { path: "/service-providers/add", exact: true, component: AddServiceProvider, permission: "add_serviceprovidermodel" },
  { path: "/service-providers/:serviceProviderId", exact: true, component: ServiceProviderProfile, permission: "view_serviceprovidermodel" },

  // media buying tools
  { path: "/plans", exact: true, component: MediaBuyerPlans, permission: ["view_mediabuyerplanmodel", "view_mediabuyer_dashboard_for_yourself", "is_head_of_mediabuyer"] },

  // reports
  { path: "/quality-cohort-report", exact: true, component: () => <ApplicationListPage title="Quality Cohort Report" href={'quality-cohort-report'}/>, permission: "view_qualitycohortreportmodel" },
  { path: "/quality-cohort-report/:app_id", exact: true, component: CohortReports, permission: "view_qualitycohortreportmodel" },

  // quality-rent-report 
  { path: "/quality-rent-report", exact: true, component: () => <ClientsListPage title="Quality Rent Report" href={'quality-rent-report'}/>, permission: "view_rentqualityreportmodel" },
  { path: "/quality-rent-report/:client_id", exact: true, component: RentStatsMain, permission: "view_rentqualityreportmodel" },

  // Invoice templates
  { path: "/invoice-templates", exact: true, component: InvoiceTemplates, permission: "view_invoicetemplatemodel"},

  // legal entity
  { path: "/legal-entity", exact: true, component: LegalEntity, permission: ["is_head_of_accountmanager", "is_admin", "is_accountmanager"] },
  { path: "/legal-entity/add", exact: true, component: AddLegalEntity, permission: "add_innercontractormodel" },
  { path: "/legal-entity/:legalEntityId", exact: true, component: LegalEntityProfile, permission: "view_innercontractormodel" },

  // account manager
  { path: "/project-manager-plans", exact: true, component: Plans, permission: "view_managerplanmodel" },
  { path: "/project-manager-plans/edit/:id", exact: true, component: EditPlansForm, permission: "view_managerplanmodel"},
  { path: "/project-manager-plans/add", exact: true, component: EditPlansForm, permission: "view_managerplanmodel"}, // Need perm

  // cabinet limits
  { path: "/cabinet-limits", exact: true, component: CabinetLimits, permission: "view_integrationcabinetlimitmodel" },

  // users actions
  { path: "/users-actions", exact: true, component: UserActionsPage, permission: ["is_admin"] },

  // upload data
  { path: "/upload-widget", exact: true, component: UploadWidget, permission: "view_fileformappingmodel" },

  // mapper files history
  { path: "/upload-history", exact: true, component: UploadHistory, permission: "view_fileformappingmodel" },

  //settings
  { path: "/users", exact: true, component: Users, permission: "view_usermodel" },
  { path: "/salary-bonuses", exact: true, component: SalaryBonuses, permission: "view_salarybonusmodel" },

  //404
  { path: "/404", exact: true, component: Page404, permission: false },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/logout", exact: true, component: Logout, permission: false },
  { path: "/", exact: true, component: Dashboard, permission: false },
  // { path: "/", exact: true, component: () => <Redirect to="/dashboard" />, permission: false },
  { path: "/", exact: false, component: () => <Redirect to="/404" />, permission: false }
]

const publicRoutes = [
  { path: "/login", exact: true, component: Login, permission: false },
  { path: "/forgot-password", exact: true, component: ForgetPwd, permission: false },
  { path: "/register", exact: true, component: Register, permission: false },
  { path: "/logout", exact: true, component: Logout, permission: false },
  { path: "/", exact: false, component: Logout, permission: false },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // { path: "/", exact: false, component: () => <Redirect to="/login" /> }
]

export const redirectPages = {
  "public": publicRoutes[0],
  "protected": authProtectedRoutes[0],
}

export { authProtectedRoutes, publicRoutes }
